import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { Trans } from "react-i18next";
import {
	getResourcePath,
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationSliderSheet } from "web_myplann/Inspiration/Components/InspirationSliderSheet";
import {
	RETIREMENT_STATE_PENSION_DEFAULT,
	RETIREMENT_STATE_PENSION_MAX,
	RETIREMENT_STATE_PENSION_MIN,
	RETIREMENT_STATE_PENSION_STEP,
} from "web_myplann/Inspiration/Retirement/constants";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";

const S = Resources.Inspiration.Retirement.StatePensionSheet;

type Props = {
	open: boolean;
	initial: number;
	onClose: () => void;
	onSubmit: (statePension: number) => void;
};

export const RetirementStatePensionSheet: FC<Props> = ({
	open,
	initial,
	onClose,
	onSubmit,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<InspirationSliderSheet
			open={open}
			copy={S}
			descriptionValues={{
				amount: formatInspirationMoney(RETIREMENT_STATE_PENSION_DEFAULT),
			}}
			initial={initial}
			min={RETIREMENT_STATE_PENSION_MIN}
			max={RETIREMENT_STATE_PENSION_MAX}
			step={RETIREMENT_STATE_PENSION_STEP}
			onClose={onClose}
			onSubmit={onSubmit}
		>
			<Stack
				bgcolor={theme.palette.surface.muted}
				borderRadius={theme.radii.lg}
				px={theme.spacingTokens.lg}
				py={theme.spacingTokens.md}
				gap={theme.spacingTokens.xsm}
			>
				<Typography variant="button" color={theme.palette.grey[500]}>
					{t(S.whereTitle)}
				</Typography>
				<Typography variant="hint" color={theme.palette.grey[500]} relaxed>
					<Trans
						i18nKey={getResourcePath(S.whereText)}
						components={{
							b: (
								<Typography
									component="span"
									variant="hint"
									color="inherit"
									strong
								/>
							),
						}}
					/>
				</Typography>
				<Typography variant="hint" color={theme.palette.grey[500]} relaxed>
					{t(S.whereNote)}
				</Typography>
			</Stack>
		</InspirationSliderSheet>
	);
};
